
/* styles */
require("!!./../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5bda5260&scoped=true!./../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ManageRecord.vue")

var Component = require("!./../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ManageRecord.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5bda5260!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ManageRecord.vue"),
  /* scopeId */
  "data-v-5bda5260",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/admin/ManageRecord.vue
// module id = 472
// module chunks = 1